import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Segment } from 'semantic-ui-react';

import { LAYOUT_TYPES } from 'Common/Components/Keyboard/constants';
import KeyboardInput from 'Common/Components/Keyboard/KeyboardInput';
import { Formatters } from 'Common/Helpers';

import 'PointOfSale/styles/components/icon.less';
import 'PointOfSale/styles/components/table.less';

const AdditionaFoodItemComponent = props => {
  const {
    additionalItems,
    handleRemove,
    handleInputChange,
    handleRemoveAllItems,
    allowUnitPriceModification,
  } = props;

  return (
    <Segment className="flex-compact flex-1 overflow-y-auto">
      <Table
        fixed
        striped
        compact
        className="secondary-header table-without-borders"
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              className="additional-food-header-cell"
              width={allowUnitPriceModification ? 'two' : 'three'}
            >
              Item
            </Table.HeaderCell>
            {allowUnitPriceModification && (
              <Table.HeaderCell
                className="additional-food-header-cell"
                width={'two'}
              >
                Unit Price
              </Table.HeaderCell>
            )}
            <Table.HeaderCell
              className="additional-food-header-cell"
              width={'one'}
            >
              Price
            </Table.HeaderCell>
            <Table.HeaderCell
              className="additional-food-header-cell"
              width={'one'}
              textAlign="center"
            >
              <Button
                compact
                color="red"
                icon="trash"
                onClick={handleRemoveAllItems}
              />
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body className="primary-color">
          {additionalItems.map((item, index) => {
            const value =
              typeof item.UnitPrice === 'number' ? '' : item.UnitPrice;

            return (
              <Table.Row key={`${item.ItemId}_${index}`}>
                <Table.Cell>{item.Description}</Table.Cell>
                {allowUnitPriceModification && (
                  <Table.Cell>
                    <KeyboardInput
                      placeholder={Formatters.currency(item.UnitPrice)}
                      onChange={e => {
                        handleInputChange(e, item.ItemId);
                      }}
                      onBlur={() => {
                        if (value !== '') {
                          handleInputChange(
                            Formatters.currency(value),
                            item.ItemId
                          );
                        }
                      }}
                      icon="dollar"
                      value={value}
                      usePortal
                      fluid
                      layoutType={LAYOUT_TYPES.NUMERIC}
                      iconPosition="left"
                    />
                  </Table.Cell>
                )}
                <Table.Cell>${item.Price.toFixed(2)}</Table.Cell>
                <Table.Cell textAlign="center">
                  <Button
                    compact
                    color="red"
                    icon="trash"
                    onClick={e => handleRemove(e, item.ItemId)}
                  />
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </Segment>
  );
};

AdditionaFoodItemComponent.propTypes = {
  additionalItems: PropTypes.array,
  handleDecrement: PropTypes.func,
  handleIncrement: PropTypes.func,
  handleRemove: PropTypes.func,
};
export default AdditionaFoodItemComponent;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/component/AdditionalFoodItem.js